import { jsx as n } from "react/jsx-runtime";
import { forwardRef as p, useMemo as c } from "react";
import d from "classnames";
import { EntityDetailsTooltipContent as $, FreeTextTooltipContent as i } from "@placer-ui/components";
import l from "./index.es442.js";
const h = {
  position: "absolute",
  width: "max-content",
  height: "max-content",
  padding: "8px",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  zIndex: 1e3,
  pointerEvents: "none",
  borderRadius: "4px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
}, u = (r, a = "top") => {
  let t = "";
  const e = "16px";
  switch (a) {
    case "center":
      t = "translate(-50%, -50%)";
      break;
    case "top":
      t = `translate(-50%, calc(-100% - ${e}))`;
      break;
    case "bottom":
      t = `translate(-50%, ${e})`;
      break;
    case "left":
      t = `translate(calc(-100% - ${e}), -50%)`;
      break;
    case "right":
      t = `translate(${e}, -50%)`;
      break;
    case "top-left-corner":
      t = `translate(calc(-100% - ${e}), calc(-100% - ${e}))`;
      break;
    case "top-right-corner":
      t = `translate(${e}, calc(-100% - ${e}))`;
      break;
    case "bottom-left-corner":
      t = `translate(calc(-100% - ${e}), ${e})`;
      break;
    case "bottom-right-corner":
      t = `translate(${e}, ${e})`;
      break;
    default:
      t = "translate(-50%, -50%)";
      break;
  }
  return {
    ...h,
    left: `${r[0]}px`,
    top: `${r[1]}px`,
    transform: t
  };
}, C = p(
  ({ componentType: r, coordinates: a, position: t, testId: e, ...o }, m) => {
    const s = c(() => t !== "center" && t !== "top-left-corner" && t !== "top-right-corner" && t !== "bottom-left-corner" && t !== "bottom-right-corner", [t]), b = d({
      [l.content]: s,
      [l[`arrow--${t}`]]: s
    }), f = c(() => r === "entity-details" ? /* @__PURE__ */ n(
      $,
      {
        ...o,
        testId: "pl-mapbox-hover-item-entity-textbox"
      }
    ) : /* @__PURE__ */ n(
      i,
      {
        ...o,
        testId: "pl-mapbox-hover-item-free-text"
      }
    ), [r, o]), x = c(() => u(a, t), [a, t]);
    return /* @__PURE__ */ n("div", { ref: m, style: x, className: b, "data-testid": e, children: f });
  }
);
export {
  C as PLMapboxHoverItem
};
//# sourceMappingURL=index.es227.js.map
